import { MAX_SEARCH_ROWS } from '../../constants';
import storage from '../storage';

/** Get the respective resource based on the location type provided
* @param {String} origin The service's origin.
* @param {String} query The search term(s) the user is looking for.
* @returns {String} URI url to web resource providing location services
*/
export default function getResource(origin, query, international) {
	let usOnly = (!international) ? '&country_iso_code=us' : '';

	return storage.get()
		.then((loc) => {
			let lat = loc.current.latitude,
				lon = loc.current.longitude,
				latlon = (lat && lon) ? `&current_loc=${lat},${lon}` : '';

			query = encodeURIComponent(query);

			return `${origin}/search/?query=${query}&fields=verbose&rows=${MAX_SEARCH_ROWS}${latlon}${usOnly}`;
		})
		.catch(e => `${origin}/search/?query=${query}&fields=verbose&rows=${MAX_SEARCH_ROWS}${usOnly}`);
}



// WEBPACK FOOTER //
// ../node_modules/@cube/location-model/src/lib/location-api/get-resource.js